import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-location-filter',
  templateUrl: './location-filter.component.html',
  styleUrls: ['./location-filter.component.scss']
})
export class LocationFilterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
